<div class="spinner">
    <svg class="spinner__svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
        <circle class="spinner__path-primary" fill="none" stroke-width="10" stroke-linecap="round" cx="50" cy="50" r="40"></circle>
        <circle class="spinner__path-secondary" fill="none" stroke-width="10" cx="50" cy="50" r="40"></circle>
    </svg>
</div>